var map = {
	"./workcase1Other1.jpg": 9746,
	"./workcase1Other2.jpg": 2653,
	"./workcase1Other3.jpg": 8080,
	"./workcase1Other4.jpg": 9731,
	"./workcase1Other5.jpg": 1206
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4022;